/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'

const SocialMediaLinks: React.FC = () => {
  useEffect(() => {})

  return (
    <div
      className='card shadow mb-5 mb-xl-10 bgi-no-repeat'
      style={{
        backgroundPosition: 'top right',
        backgroundSize: '100% auto',
        backgroundImage: `url(${toAbsoluteUrl('/media/svg/shapes/abstract-1.svg')})`,
      }}
    >
      <div className='card-body pt-9 pb-9'>
        <div className='flex-grow-1'>
          <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
            <div className='d-flex flex-column'>
              <div className='d-flex align-items-center mb-2'>
                <a
                  className='text-black text-hover-primary fs-2 fw-bolder me-1'
                  style={{textTransform: 'capitalize'}}
                >
                  Social Media
                </a>
              </div>
            </div>
          </div>
          <div className='d-flex flex-wrap flex-stack'>
            <a
              className=' hoverable'
              href='https://www.linkedin.com/company/futurisk-insurance-broking-pvt-ltd/mycompany/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <KTSVG
                path='/media/svg/social-logos/linkedin-svgrepo-com.svg'
                className='svg-icon-1'
              />
            </a>
            <a
              className=' hoverable'
              href='https://www.facebook.com/Futuriskinsurance'
              target='_blank'
              rel='noopener noreferrer'
            >
              <KTSVG path='/media/svg/social-logos/facebook.svg' className='svg-icon-2' />
            </a>
            <a
              className=' hoverable'
              href='https://www.instagram.com/futurisk_the_insurance_coach/?next=%2F'
              target='_blank'
              rel='noopener noreferrer'
            >
              <KTSVG path='/media/svg/social-logos/instagram.svg' className='svg-icon-2' />
            </a>
            <a
              className=' hoverable'
              href='https://twitter.com/futurisk_in?lang=en'
              target='_blank'
              rel='noopener noreferrer'
            >
              <KTSVG path='/media/svg/social-logos/twitter.svg' className='svg-icon-1' />
            </a>
            <a className=' hoverable' href='' target='_blank' rel='noopener'>
              <KTSVG path='/media/svg/social-logos/youtube.svg' className='svg-icon-1' />
            </a>
          </div>
          <div className='mb-10'></div>
          <div className='d-flex flex-wrap flex-stack'>
            {/* <a
              className={` hoverable   `}
              target='_blank'
              rel='noopener noreferrer'
              href='https://whatsapp.com/channel/0029VaI1QQDFi8xi6VztwJ0w'
            >
              <img
                src={toAbsoluteUrl('/media/partner/WhatsApp.png')}
                width='100%'
                alt='WhatsApp'
                className='card-p-5 shadow'
                style={{borderRadius: 8}}
              />
            </a> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export {SocialMediaLinks}
